'use strict';

const helper = require('../util/helpers');

module.exports = () => {
    if (!window.DYO) {
        console.error('no window.DYO');
        return;
    }
    $('form.login').on('login:success', (e) => {
        const formData = $(e.target).serializeArray();
        const email = formData.find(field => field.name.match(/loginEmail$/)).value;
        const hashedEmail = window.DYO.dyhash.sha256(email);
        const eventData = {
            detail: {
                name: 'Login',
                properties: {
                    dyType: 'login-v1',
                    hashedEmail
                }
            }
        }
        helper.triggerIdentifyEvent(email);
        document.body.dispatchEvent(new CustomEvent('dynamicYieldEvent', eventData));
    });
    $('form.registration').on('login:register:success', (_, data) => {
            const email = data.emailConfirm;
            const isSignUp = data.form.customer.addtoemaillist.selected;
            helper.triggerSignUpEvent(email);
            helper.triggerIdentifyEvent(email);

            if (!isSignUp) {
                return;
            }

            helper.triggerNewsletterSignup(email);
    });
    $('body').on('checkout:paymentAccepted', (_, data) => {
        helper.triggerNewsletterSignup(data.email.value);
        helper.triggerIdentifyEvent(data.email.value);
    });
};
